module.exports = __webpack_public_path__ + "static/img/10.f64b689.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/zh/10.png
// module id = 8fBC
// module chunks = 0